/**
 * Qué falló al hablar con el servidor, en palabras de la persona (M7, auditoría 2026-10-02).
 *
 * Antes la bandeja decía siempre «Revisa tu conexión» (fuera un 502, un 500 o
 * un correo que ya no existe) y las acciones decían «Error en la acción». Aquí
 * se separa lo que la persona puede arreglar (su red) de lo que no (Orvian o el
 * proveedor), y se usa el `detail` del servidor cuando lo trae en español.
 */
export function describirErrorRed(err) {
  const r = err?.response;
  const detail = typeof r?.data?.detail === 'string' ? r.data.detail : null;
  if (!r) {
    const sinRed = typeof navigator !== 'undefined' && navigator.onLine === false;
    return sinRed
      ? { titulo: 'Sin conexión a internet', texto: 'Revisa tu red. En cuanto vuelva, inténtalo de nuevo.' }
      : { titulo: 'Orvian no responde', texto: 'No pudimos contactar con el servidor. Inténtalo de nuevo en un momento.' };
  }
  if (r.status >= 500) {
    return {
      titulo: 'Problema en el servidor',
      texto: detail || 'Orvian o tu proveedor de correo tuvo un problema. Inténtalo de nuevo en un momento.',
    };
  }
  if (r.status === 404) return { titulo: 'Ya no está', texto: detail || 'El correo o la carpeta ya no existe; quizá se movió desde otro dispositivo.' };
  if (r.status === 403) return { titulo: 'Sin permiso', texto: detail || 'Tu cuenta no tiene permiso para hacer esto.' };
  return { titulo: 'No se pudo completar', texto: detail || 'Inténtalo de nuevo.' };
}

/** Una sola línea para un toast: «No se pudo archivar: Orvian no responde…». */
export function mensajeErrorRed(err, accion) {
  const { titulo, texto } = describirErrorRed(err);
  const cuerpo = err?.response ? texto : `${titulo}. ${texto}`;
  return accion ? `No se pudo ${accion}. ${cuerpo}` : cuerpo;
}
